import * as type from '../ActionTypes';

export function getUserInfo() {
  return {
    type: type.GET_USER_INFO_REQUEST
  };
}

export function clearUserInfo() {
  return {
    type: type.CLEAR_USER_INFO
  };
}
